import { axiosApi } from 'app/api/api';
import { FileData } from 'entities/file/model/fileModel';
import {
  CreateFolderParams,
  FolderData,
  MergeFoldersParams,
  UpdateFolderParams,
} from 'entities/folder/model/folderModel';
import { TableData } from 'entities/table/model/tableModel';
import { SortContentKey, SortContentOrder } from 'entities/types';

export const foldersApi = {
  fetch: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<FolderData>(`/folder/${id}`, {
      params: { in_trash },
    });

    return res.data;
  },
  create: async (params: CreateFolderParams, section_id: string) => {
    const res = await axiosApi.post<FolderData>('/folder', {
      ...params,
      section_id,
    });

    return res.data;
  },
  update: async (params: UpdateFolderParams, folder_id: string) => {
    const res = await axiosApi.put<FolderData>(`/folder/${folder_id}`, params);

    return res.data;
  },
  delete: async (id: string) => {
    await axiosApi.delete<void>(`/folder/${id}`);

    return id;
  },
  merge: async (params: MergeFoldersParams) => {
    const res = await axiosApi.post<FolderData>(`/folder/merge`, params);

    return res.data;
  },
  getContent: async (
    id: string,
    params: {
      in_trash: string | null;
      sort_by: SortContentKey;
      sort_direction: SortContentOrder;
    }
  ) => {
    const res = await axiosApi.get<{ content: any[] }>(
      `/folder/${id}/content`,
      { params }
    );

    return res.data.content;
  },
  fetchFolders: async (
    id: string,
    { in_trash }: { in_trash: string | null }
  ) => {
    const res = await axiosApi.get<{ folders: FolderData[] }>(
      `/folder/sub_folders/${id}`,
      { params: { in_trash } }
    );

    return res.data.folders;
  },
  fetchFiles: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<{ files: FileData[] }>(
      `/folder/files/${id}`,
      { params: { in_trash } }
    );

    return res.data.files;
  },
  fetchTables: async (
    id: string,
    { in_trash }: { in_trash: string | null }
  ) => {
    const res = await axiosApi.get<{ tables: TableData[] }>(
      `/folder/get_tables/${id}`,
      { params: { in_trash } }
    );

    return res.data.tables;
  },
};
